module.exports = __webpack_public_path__ + "48f90afaf53c830eb6e28d9e3af32b.png";